import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.5 6h-15c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h15c.275 0 .5.225.5.5s-.225.5-.5.5zM16 8.5c0-.275-.225-.5-.5-.5h-11c-.275 0-.5.225-.5.5s.225.5.5.5h11c.275 0 .5-.225.5-.5zm-2 3c0-.275-.225-.5-.5-.5h-7c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5zm-2 3c0-.275-.225-.5-.5-.5h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5z',
  ],
  height: 20,
  width: 20,
});
